  function subscription_perks(){
        if($(window).width() <= 640) {
        $('.subscription-perks .multi-column__grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows:true,
        });
    }else{
          if($('.subscription-perks  .multi-column__grid').hasClass('slick-initialized')) {
        $('.subscription-perks .multi-column__grid').slick('unslick');
      }
      
    }
  }
  function training_icon(){
        if($(window).width() <= 640) {
        $('.training-icon .multi-column__grid').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows:true,
        });
    }else{
          if($('.training-icon  .multi-column__grid').hasClass('slick-initialized')) {
        $('.training-icon .multi-column__grid').slick('unslick');
      }
      
    }
  }
$(function(){
  subscription_perks();
  training_icon();
  $(window).resize(function () {
    subscription_perks();
    training_icon();
  });
 $('.grid-video-enable').click(function () {
      $(this).parent().find('.video__inner .video').attr('controls','controls');
       $(this).parent().find('.video__inner').css('z-index','999999');
     if($(window).width() <= 640) {
         if($(this).parent().find('.video__inner .grid-mobile-video').length){
           $(this).parent().find('.video__inner .grid-mobile-video').get(0).play();
         }else{
           $(this).parent().find('.video__inner .video').get(0).play();
         }
       }else{
           $(this).parent().find('.video__inner .video').get(0).play();
     }
    
  });

  
});


 $(function() {

        jQuery('.read-more-collection').click(function(){
        if(jQuery('#truncated').is(":visible")){
            jQuery('#truncated').hide();
            jQuery('#fullDescription').show();
            }
        else{
            jQuery('#truncated').show();
            jQuery('#fullDescription').hide();
        }
        });

});

